import { SelectAsyncInput } from '@core/components/Select';
import { compraApi } from 'app/services/api/compraApi';
import React from 'react';

const SelectCompra = ({ id, name, label, value, touched, error, onBlur, onChange, required, disabled }) => {
  return (
    <SelectAsyncInput
      id={id}
      required={required}
      name={name}
      label={label}
      value={value}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        if (option?.id) return `Compra ${option.compraId} - ${option?.fornecedor?.pessoa?.nome}`;
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }

        const response = await compraApi().buscarTodos({
          size: 100,
          sort: 'vencimento',
          page: next,
          q: query,
        });
        const data = response?.data?.content || [];

        data.forEach((compra) => {
          compra.compraId = compra.compraId.toString().padStart(3, '0');
        });

        return { data, nextPage: next, totalItems: data.totalElements };
      }}
      fetchOnFocus
      disabled={disabled}
    />
  );
};

export default SelectCompra;
